

































































































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import DateComponent from "@/components/common/Inputs/Date.vue";
import { AppConstants as _app } from "@/shared/app.constants";
import { Grant } from "@/entities";

@Component({
    components: {
        DateComponent
    }
})
export default class FinancialReportingPeriod extends Vue {

    @Prop() readOnly: boolean;
    @Prop() grantId: number; 
    @Prop() modelWrapper: any;
    @Prop() grantInfo: Grant;
    @Prop() isAgreementSigned: any;
    @Action("showNotification", { namespace: 'application' }) notify: any;
    actions = _app.actions;
    subjects = _app.subjects;
    finPeriodKey: number = 1;
    selectedFrequency: number = _app.reportingPeriods.technical;

    // reporting frequency dropdown options
    reportingFrequency: any = [
        { dispalyText: 'Quarter', abbr: 'Q', value: 3 },
        { dispalyText: 'Half year', abbr: 'H', value: 6 },
        { dispalyText: 'Year', abbr: 'Y', value: 12 }
    ];

    mounted() {
        this.addEmptyRow();
    }

    getReportinPeriods() {
        this.modelWrapper.financialReportingPeriods = this.$services.agreement.getReportingPeriods( 
            this.grantInfo.ActualStartDate || this.grantInfo.StartDate, 
            this.grantInfo.ExpectedEndDate || this.grantInfo.EndDate, 
            this.selectedFrequency || _app.reportingPeriods.technical
        );
        this.addEmptyRow();
    }

    finPeriods() {
        if(this.modelWrapper.financialReportingPeriods) {
            return this.modelWrapper.financialReportingPeriods;
        } else {
            this.modelWrapper.financialReportingPeriods = [ {} ];
            return this.modelWrapper.financialReportingPeriods;
        }
    }

    addEmptyRow(){
        if(this.modelWrapper.financialReportingPeriods){
            const emptyRow = this.modelWrapper.financialReportingPeriods.find(x => Object.keys(x).length === 0);
            if(!emptyRow) {
                this.modelWrapper.financialReportingPeriods.push({});
                this.finPeriodKey += 1;
            }
        }
        // this.finPeriodKey += 1;
    }

    /** event period changed */
    periodChanged(doc, val, index) {
        var periods = this.$services.agreement.updatePeriod(
            this.modelWrapper.financialReportingPeriods, 
            doc, 
            index, 
            this.modelWrapper, 
            this.selectedFrequency || _app.reportingPeriods.technical,
            this.grantInfo.ActualStartDate || this.grantInfo.StartDate,
            this.grantInfo.ExpectedEndDate || this.grantInfo.EndDate
        );
        this.modelWrapper.financialReportingPeriods = periods;
        this.addEmptyRow();
        this.finPeriodKey += 1;
    }

    /** validate the start date */
    validateStartDate(doc, val, index) {
        const msg = this.$services.agreement.validateStartDate(
            this.modelWrapper.financialReportingPeriods, 
            doc, 
            index, 
            val, 
            this.modelWrapper,
            this.grantInfo.ActualStartDate || this.grantInfo.StartDate,
            this.grantInfo.ExpectedEndDate || this.grantInfo.EndDate
        )
        if(msg) {
            this.notify(
                {
                    text: msg,
                    isHtml: true,
                    color: "error"
                }
            );
        } else {
            doc.startDate = val;
            this.addEmptyRow(); 
            this.finPeriodKey += 1;
        }   
    }

    /** validate the end date */
    validateEndDate(doc, val, index) {

        const msg = this.$services.agreement.validateEndDate(
            this.modelWrapper, 
            doc, 
            index, 
            val, 
            "financialReportingPeriods", 
             this.selectedFrequency || _app.reportingPeriods.technical,
            this.grantInfo.ActualStartDate || this.grantInfo.StartDate,
            this.grantInfo.ExpectedEndDate || this.grantInfo.EndDate
             )
        
        if(msg) {
            this.notify(
                {
                    text: msg,
                    isHtml: true,
                    color: "error"
                }
            );
        } else {
            doc.endDate = val;
            this.addEmptyRow(); 
            this.finPeriodKey += 1;
        }   
    }

    /** validate the due date */
    validateDueDate(doc, val, index) {

        const msg = this.$services.agreement.validateDueDate(
            this.modelWrapper.financialReportingPeriods, 
            doc, 
            index, 
            val, 
            this.modelWrapper,
            this.grantInfo.ActualStartDate || this.grantInfo.StartDate,
            this.grantInfo.ExpectedEndDate || this.grantInfo.EndDate
        )
        
        if(msg) {
            this.notify(
                {
                    text: msg,
                    isHtml: true,
                    color: "error"
                }
            );
        } else {
            doc.dueDate = val;
            this.addEmptyRow(); 
            this.finPeriodKey += 1;
        }   
    }
    
    onRemoveRow(index, doc) {
        this.modelWrapper.financialReportingPeriods.splice(index, 1);
        // this.$emit('fileChange', doc);
        this.addEmptyRow();   
        this.finPeriodKey += 1;
 
    }

    get buttonVisibility() {
        //@ts-ignore
        if(this.$can(this.actions.manage, this.subjects.grantAgree)) {
            // secratariat users with just review only roles have only read permission
            return true;
        }
    }
    
}
